/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { GraphQLInstrumentation } from './instrumentation';
export type {
  GraphQLInstrumentationConfig,
  GraphQLInstrumentationExecutionResponseHook,
  GraphQLInstrumentationParsedConfig,
} from './types';
